import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

const Logout = () => {
  const { logout } = useAuth();

  useEffect(() => {
    // Clears local auth state + storage, then redirects to the backend /auth/logout endpoint
    // which clears the session cookie (and Entra session) and returns to the SPA login page.
    logout();
  }, [logout]);

  return null;
};

export default Logout;
